<template>
  <div class="row align-items-center mt-2">
    <div class="col-sm-12">
      <div class="page-title-box">
        <h4 class="font-size-18">{{ title }}</h4>
        <ol class="breadcrumb mb-0 mt-n2">
          <li class="breadcrumb-item active">{{ description }}</li>
        </ol>
      </div>
    </div>
  </div>
  <!-- end page title -->
</template>
<script>
export default {
  components: {},
  props: {
    description: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  methods: {},
};
</script>
<style scoped>
.breadcrumb-item + .breadcrumb-item::before {
  content: '>';
  color: #d16913bd;
}
</style>
